'use client';

import { c as _c } from "react/compiler-runtime";
import { useCourseLandingComponentsApi } from '@/lib/hooks/use-course-landing-components-api';
import { useIsLoggedIn } from '@/lib/hooks/use-is-logged-in';
import { useUserHasOrganization } from '@/lib/hooks/use-user-has-organization';
import { OneClickCheckoutContext, OneClickCheckoutApiResponse } from '@/types/one-click-checkout-context';
export function useOneClickCheckoutContext(courseId) {
  const $ = _c(6);
  const isLoggedIn = useIsLoggedIn();
  const userHasOrganization = useUserHasOrganization();
  const t0 = isLoggedIn && !userHasOrganization;
  let t1;
  if ($[0] !== t0) {
    t1 = {
      enabled: t0
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const query = useCourseLandingComponentsApi(courseId, "one_click_checkout", t1);
  const t2 = query.data?.one_click_checkout as OneClickCheckoutContext | undefined;
  const t3 = (query.error ?? undefined) as Error | undefined;
  let t4;
  if ($[2] !== query.isLoading || $[3] !== t2 || $[4] !== t3) {
    t4 = {
      data: t2,
      isLoading: query.isLoading,
      error: t3
    };
    $[2] = query.isLoading;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}